module.exports = __webpack_public_path__ + "img/flower.c9528f15.svg";